<template>
  <div>
    <b-table
      v-if="dataTableMap && dataTableMap.length && !loadingTable"
      bordered
      striped
      responsive
      :per-page="table.perPage"
      :items="dataTableMap"
      :fields="fieldsTable"
    >
      <template #cell(descarga)="data">
        <div
          v-if="
            data.item.avance !== '100' &&
            data.item.estadoarchivo !== '2'
          "
          class="d-flex"
        >
          <b-button size="sm" variant="success-outline" disabled>
            <b-spinner small type="grow"></b-spinner>
            Descargando...
          </b-button>
          <b-button
            variant="danger"
            @click="cancelarGeneracion(data.item.id)"
            size="sm"
            title="Cancelar Descarga"
          >
            <span style="color: white">
              <i class="fas fa-x" aria-hidden="true"></i>
            </span>
          </b-button>
        </div>

        <b-button
          v-if="data.item.urlcarpeta"
          variant="primary"
          @click="verCarpeta(data.item.urlcarpeta)"
          size="sm"
          title="Abrir"
        >
          <span style="color: white">
            <i class="fas fa-download" aria-hidden="true" />
          </span>
        </b-button>
        <div v-if="data.item.estadoarchivo === '2'">
          <label>Cancelado</label>
        </div>
      </template>
    </b-table>

    <b-skeleton-wrapper v-if="loadingTable">
      <b-skeleton v-for="i in 15" :key="i" width="100%" height="50px" />
    </b-skeleton-wrapper>

    <div class="w-100 d-flex justify-content-center">
      <b-pagination
        v-model="table.currentPage"
        :total-rows="table.totalRows"
        :per-page="table.perPage"
        aria-controls="my-table"
        first-number
        last-number
        @change="onChangePage"
      />
    </div>
  </div>
</template>

<script>
import rutas from "@/assets/utils/rutas.json";
import rutasrep from "@/assets/utils/rutas.json";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";
import JSZip from "jszip";

import {
  loadEspecialidadesOpts,
  loadTipoSegurosOpts,
  loadTipoCoberturaOpts,
  loadTipoServiciosOpts,
} from "../helpers";
import { obtenerDataTablePlanos } from "../services/archivosPlanos";

export default {
  name: "PlanoTableComponent",

  data() {
    return {
      table: {
        currentPage: 1,
        perPage: 15,
        totalRows: 0,
      },

      loadingTable: false,
      dataTable: null,
      dataTableMap: null,
      segurosSaludOpts: [],
      tipoCoberturaOpts: [],
      especialidadesOpts: [],
      tipoServicioOpts: [],
      progress: 0,
      isLoading: false,
      indexItem: null,
      archivozip: null,

      fields: [
     
        { key: "fechaproceso", label: "fecha proceso", thClass: "text-center" },
        { key: "finicio", label: "desde", thClass: "text-center" },
        { key: "ffin", label: "hasta", thClass: "text-center" },
        { key: "doctor", label: "doctor", thClass: "text-center" },
        { key: "paciente", label: "paciente", thClass: "text-center" },
        { key: "especialidad", label: "especialidad", thClass: "text-center" },
        { key: "segurosalud", label: "seguro", thClass: "text-center" },
        { key: "tipocobertura", label: "cobertura", thClass: "text-center" },
        { key: "tiposervicio", label: "servicio", thClass: "text-center" },
        { key: "usuario", label: "usuario", thClass: "text-center" },
        { key: "descarga", label: "descarga", thClass: "text-center" },
      ],

      fieldsTable: [
  
        { key: "fechaproceso", label: "fecha proceso", thClass: "text-center" },
        { key: "finicio", label: "desde", thClass: "text-center" },
        { key: "ffin", label: "hasta", thClass: "text-center" },
        { key: "doctor", label: "doctor", thClass: "text-center" },
        { key: "paciente", label: "paciente", thClass: "text-center" },
        { key: "especialidad", label: "especialidad", thClass: "text-center" },
        { key: "segurosalud", label: "seguro", thClass: "text-center" },
        { key: "tipocobertura", label: "cobertura", thClass: "text-center" },
        { key: "tiposervicio", label: "servicio", thClass: "text-center" },
        { key: "usuario", label: "usuario", thClass: "text-center" },
        { key: "descarga", label: "descarga", thClass: "text-center" },
      ],
    };
  },

  async created() {
    this.loadingTable = true;
    await this.loadDataInitForm();
    await this.getDataTable();
  },

  methods: {
    async cancelarGeneracion(id) {
      const query = `mutation MyMutation {
        cancelarDescargaXLS(aplanoid: ${id}) {
          message
        }
      }`;
      try {
        const response = await axios.post(rutasrep.axiosrep + "api", { query });
        if (
          response &&
          response.data.data.cancelarDescargaXLS.message === "success"
        ) {
          await this.$swal({
            title: "Cancelado",
            text: "Descarga cancelada",
            icon: "success",
            confirmButtonText: "Entendido",
          });
          this.$router.go(0);
        } else {
          await this.$swal({
            title: "Error",
            text: "ERROR",
            icon: "warning",
            confirmButtonText: "Entendido",
          });
          this.$router.go(0);
        }
      } catch (error) {
        console.log("error en cancelar descarga");
      }
    },
    async getDataTable() {
      this.loadingTable = true;

      const params = {
        page: this.table.currentPage,
        pageSize: this.table.perPage,
      };

      const responsePlanos = await obtenerDataTablePlanos(params);
      this.dataTable = responsePlanos.data;

      console.log("dataTable", this.dataTable);

      const dataTableMap = this.dataTable.map((item) => {
        const doctor = item.doctor
          ? `${item.doctor.idPersona.primerNombre} ${item.doctor.idPersona.primerApellido}`
          : "TODOS";

        const paciente = item.paciente
          ? `${item.paciente.persona.primerNombre} ${item.paciente.persona.primerApellido}`
          : "TODOS";

        const especialidad = this.getDescription(
          item.especialidad,
          "dependencias"
        );
        const tipoCobertura = this.getDescription(
          item.tipocobertura,
          "tipocobertura"
        );
        const seguroSalud = this.getDescription(
          item.segurosalud,
          "segurosalud"
        );
        const tipoServicio = this.getDescription(
          item.tiposervicio,
          "tiposervicio"
        );

        return {
          id: item.id,
          establecimiento: item.establecimiento?.Descripcion || "TODOS",
          fechaproceso: item.fechaproceso,
          finicio: item.finicio,
          ffin: item.ffin,
          doctor: doctor,
          paciente: paciente,
          especialidad: especialidad,
          segurosalud: seguroSalud,
          tipocobertura: tipoCobertura,
          tiposervicio: tipoServicio,
          usuario: item.usuarioCreador.username,
          urlcarpeta: item.urlcarpeta,
          avance: item.avance,
          estadoarchivo: item.estadoarchivo,
        };
      });

      this.dataTableMap = dataTableMap;

      this.table.totalRows = responsePlanos.total;

      this.loadingTable = false;
    },

    onChangePage(page) {
      this.table.currentPage = page;
      this.getDataTable();
    },

    async verCarpeta(url) {
      if (url) {
        const fullDownloadUrl = `${rutasrep.axiosrep}file/showplanos/${url}`;

        try {
          this.urlCarpeta = fullDownloadUrl;
          window.open(fullDownloadUrl, "_blank");
        } catch (error) {
          this.$swal({
            title: "Error",
            text: "Un error ocurrio mientras descarga el archivo",
            icon: "error",
            confirmButtonText: "Entendido",
          });
        }
      } else {
        this.$swal({
          title: "Campos vacíos",
          text: "El archivo no ha sido subido",
          icon: "error",
          confirmButtonText: "Entendido",
        });
      }
    },

    // async downloadPlanos(index, id, tipo) {

    //   let query = ''
    //   if (tipo === 1) {
    //     query = `
    //       query MyQuery {
    //         archivoPlanocsv(aplanoid: ${id}) {
    //           csvarchivo
    //         }
    //       }
    //     `;
    //   } else if (tipo === 2) {
    //     query = `
    //       query MyQuery {
    //         archivoPlanoxls(aplanoid: ${id}) {
    //           xlsarchivo
    //           message
    //         }
    //       }
    //     `;
    //   }

    //   try {
    //     this.indexItem = index;
    //     this.isLoading = true;
    //     this.progress = 0;

    //     const progressInterval = setInterval(() => {
    //       if (this.progress < 99) {
    //         this.progress += 10;
    //       }
    //     }, 10000);

    //     const response = await axios.post(rutasrep.axiosrep + 'api', { query });

    //     if (response.status === 200) {
    //       alert("entra aqui")
    //       this.progress = 100;
    //       clearInterval(progressInterval);

    //       const data = response.data.data.archivoPlanoxls
    //       console.log("esta es la data", data)

    //       if (data) {
    //           this.$router.go(0)

    //       } else {
    //         this.$swal({
    //           title: 'Info',
    //           text: 'No hay archivos para descargar',
    //           icon: 'warning',
    //           confirmButtonText: 'Entendido'
    //         });
    //       }

    //       if(this.progress === 100){
    //         this.isLoading = false;
    //       }
    //     }
    //   } catch (error) {
    //     console.log(error);
    //     this.isLoading = false;
    //     this.progress = 0;
    //   }
    // },

    base64ToArrayBuffer(base64) {
      try {
        const binaryString = window.atob(base64);
        const len = binaryString.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
          bytes[i] = binaryString.charCodeAt(i);
        }
        return bytes.buffer;
      } catch (e) {
        console.error("Error decodificando Base64:", e);
        return null;
      }
    },

    async generateZip(base64Data, tipo) {
      const zip = new JSZip();
      const contenido = this.base64ToArrayBuffer(base64Data);
      const uuid = uuidv4();

      if (tipo === 1) {
        zip.file(`ArchivoPlano${uuid}.csv`, contenido);
      } else if (tipo === 2) {
        zip.file(`ArchivoPlano${uuid}.xlsx`, contenido);
      }

      try {
        const archivoZip = await zip.generateAsync({ type: "base64" });
        const link = document.createElement("a");
        link.href = "data:application/zip;base64," + archivoZip;
        link.download = "archivos.zip";
        link.click();
      } catch (error) {
        console.error("Error generando el ZIP:", error);
      }
    },

    async loadDataInitForm() {
      this.segurosSaludOpts = await loadTipoSegurosOpts();
      this.tipoCoberturaOpts = await loadTipoCoberturaOpts();
      this.especialidadesOpts = await loadEspecialidadesOpts();
      this.tipoServicioOpts = await loadTipoServiciosOpts();
    },

    getDescription(data, area) {
      if (data && area === "segurosalud") {
        let esArreglo = this.esUnArreglo(data, this.segurosSaludOpts, true);

        if (!esArreglo) {
          const foundItem = this.segurosSaludOpts.find(
            (item) => item.codigo === data
          );
          return foundItem ? foundItem.text : "";
        } else {
          return esArreglo;
        }
      }
      if (data && area === "tipocobertura") {
        let esArreglo = this.esUnArreglo(data, this.tipoCoberturaOpts, true);
        if (!esArreglo) {
          const foundItem = this.tipoCoberturaOpts.find(
            (item) => item.codigo === data
          );
          return foundItem ? foundItem.text : "";
        } else {
          return esArreglo;
        }
      }

      if (data && area === "dependencias") {
        let esArreglo = this.esUnArreglo(data, this.especialidadesOpts, true);

        if (!esArreglo) {
          const foundItem = this.especialidadesOpts.find(
            (item) => item.codigo === data
          );
          return foundItem ? foundItem.text : "";
        } else {
          return esArreglo;
        }
      }
      if (data && area === "tiposervicio") {
        let esArreglo = this.esUnArreglo(data, this.tipoServicioOpts);
        if (!esArreglo) {
          const foundItem = this.tipoServicioOpts.find(
            (item) => item.value === data
          );
          return foundItem ? foundItem.text : "";
        } else {
          return esArreglo;
        }
      }

      return "";
    },

    esUnArreglo(data, area, cod) {
      let datos = null;

      if (data.includes(",")) {
        datos = data.split(",").map((item) => item.trim());
        console.log("entra aqui", data);
      }
      if (datos && cod) {
        let info = [];
        for (let i = 0; i < datos.length; i++) {
          let foundinArray = area.find((item) => item.codigo === datos[i]);
          info.push(foundinArray?.text);
        }
        console.log("info", info);
        info = info.join(", ");
        return info;
      } else if (datos) {
        let info = [];
        for (let i = 0; i < datos.length; i++) {
          let foundinArray = area.find((item) => item.value === datos[i]);
          info.push(foundinArray.text);
        }
        console.log(info);
        info = info.join(", ");
        return info;
      } else {
        return null;
      }
    },
  },
};
</script>
